"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_Select = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _selectModule = _interopRequireDefault(require("./select.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * @deprecated This component will be removed in version 29. Please use the new `Select` component from `/src/components/select` instead.
 */
var DEPRECATED_Select = exports.DEPRECATED_Select = function DEPRECATED_Select(_ref) {
  var id = _ref.id,
    className = _ref.className,
    options = _ref.options,
    optgroup = _ref.optgroup,
    name = _ref.name,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    required = _ref.required,
    dataTestId = _ref['data-testid'],
    ariaInvalid = _ref.ariaInvalid,
    ariaDescribedBy = _ref.ariaDescribedBy,
    ariaLabel = _ref.ariaLabel,
    _ref$value = _ref.value,
    propValue = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur;
  var selectRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(propValue || (0, _get.default)(options, '[0].value')),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  (0, _react.useEffect)(function () {
    setValue(propValue);
  }, [propValue]);
  var handleChange = function handleChange(evt) {
    var newValue = evt.target.value;
    setValue(newValue);
    onChange(evt);
  };
  var handleFocus = function handleFocus(evt) {
    setValue(evt.target.value);
    onFocus(evt);
  };
  var handleBlur = function handleBlur(evt) {
    setValue(evt.target.value);
    onBlur(evt);
  };
  var noOptions = !options || options.length === 0;
  var noOptGroup = !optgroup || optgroup.length === 0;
  if (noOptGroup && noOptions) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
    ref: selectRef,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": ariaInvalid,
    "aria-label": ariaLabel
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: autoFocus,
    className: (0, _classnames.default)(_selectModule.default['c-select'], className),
    "data-jlds": true,
    "data-testid": dataTestId,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    required: required,
    value: value,
    children: [options === null || options === void 0 ? void 0 : options.map(function (option) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        "data-jlds": true,
        disabled: option.disabled,
        hidden: option.hidden,
        value: option.value,
        children: option === null || option === void 0 ? void 0 : option.label
      }, option.value);
    }), optgroup === null || optgroup === void 0 ? void 0 : optgroup.map(function (optgroupItem) {
      var _optgroupItem$options;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("optgroup", {
        label: optgroupItem.label,
        children: optgroupItem === null || optgroupItem === void 0 || (_optgroupItem$options = optgroupItem.options) === null || _optgroupItem$options === void 0 ? void 0 : _optgroupItem$options.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            "data-jlds": true,
            disabled: option.disabled,
            hidden: option.hidden,
            value: option.value,
            children: option === null || option === void 0 ? void 0 : option.label
          }, option.value);
        })
      }, optgroupItem.label);
    })]
  });
};
DEPRECATED_Select.propTypes = {
  /** Unique ID for the select element */
  id: _propTypes.default.string.isRequired,
  /** Custom class name to be added */
  className: _propTypes.default.string,
  /** Array of options to be presented */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _staticContentPropCheck.default,
    disabled: _propTypes.default.bool,
    hidden: _propTypes.default.bool
  })).isRequired,
  /** Array of optgroup to be presented */
  optgroup: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _staticContentPropCheck.default,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _staticContentPropCheck.default,
      disabled: _propTypes.default.bool,
      hidden: _propTypes.default.bool
    }))
  })),
  /** Optional data-testid attribute */
  'data-testid': _propTypes.default.string,
  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes.default.string,
  /** Set the aria-label attribute */
  ariaLabel: _propTypes.default.string,
  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes.default.string,
  /** Name of the select element */
  name: _propTypes.default.string.isRequired,
  /** Default value to use if none is selected - this is non-standard to HTML */
  value: _propTypes.default.string,
  /** Disable the select element */
  disabled: _propTypes.default.bool,
  /** Function to be called when a change event is fired by the select */
  onChange: _propTypes.default.func,
  /** Function to be called when the select accepts focus */
  onFocus: _propTypes.default.func,
  /** Function to be called when the select loses focus */
  onBlur: _propTypes.default.func,
  /** Focus on this input when the page loads */
  autoFocus: _propTypes.default.bool,
  /** Mark the select element as a required field */
  required: _propTypes.default.bool
};